module.exports = __webpack_public_path__ + "img/1234.73326feb.jpg";